import styled from 'styled-components';

export const AddressWarningModalStyles = styled.div`
  .address-warning-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: ${({ theme: { token } }) => token.paddingMD}px 0;
  }

  .address-warning-icon {
    font-size: 48px;
    color: ${({ theme: { token } }) => token.colorWarning};
    margin-bottom: ${({ theme: { token } }) => token.marginMD}px;
  }

  .address-warning-title {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading4 || token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong || 600};
    color: ${({ theme: { token } }) => token.colorText};
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
  }

  .address-warning-description {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    line-height: 1.5;
  }

  .address-warning-actions {
    display: flex;
    justify-content: center;
    gap: ${({ theme: { token } }) => token.marginMD}px;
    width: 100%;
  }
`;
